import { useState, useEffect, useRef } from 'react';
import type { RefObject } from 'react';

type ObservedElement = HTMLDivElement;

const useVisibilityOnScroll = (threshold = 0.1, runOnce?: boolean) : [RefObject<ObservedElement | null>, boolean] => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef<ObservedElement>(null); 

  useEffect(() => {
    const currentElement = elementRef.current;
    
    if (!currentElement) {
      return; 
    }
    
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); 
        if (entry.isIntersecting && runOnce) {
           observer.unobserve(entry.target);
        }
      },
      {
        root: null,
        threshold: threshold, 
      }
    );

    observer.observe(currentElement);

    return () => {
      observer.unobserve(currentElement);
    };
  }, [threshold, runOnce]); 

  return [elementRef, isVisible];
}

export const animationStyle = {
  opacity: 0,
  transform: 'translateY(20px)',
  transition: 'opacity 0.5s ease-out, transform 0.5s ease-out',
};

export const visibleStyle = {
  opacity: 1,
  transform: 'translateY(0)',
};

export default useVisibilityOnScroll;